import React from 'react';
import {WhiteBox} from "../appointment/WhiteBox";
import {Box, Grid} from "@mui/material";
import {getShortenDateWithDayOfWeek} from "../../utils/Utils";

export interface CurrentVotedBoxProps {
    absentDates: Date[];
    attendDates: Date[];
}

export const CurrentVotedBox: React.FC<CurrentVotedBoxProps> = ({ absentDates, attendDates }) => {
    if (absentDates.length == 0 && attendDates.length == 0) {
        return <></>;
    }

    const dateSpans = (dates: Date[]) => {
        const sorted = [...dates].sort((a, b) => a.getTime() - b.getTime());
        return sorted.map((date, index) => {
            return (
                <span key={index} style={{fontWeight: 400}}>{getShortenDateWithDayOfWeek(date)} </span>
            )
        })
    }

    return (
        <WhiteBox>
            <span>내가 선택한 날짜</span>
            <Box height={'20px'}/>
            {attendDates.length > 0 &&
                <>
                    <Grid container spacing={1} sx={{fontSize: '13px'}}>
                        <Grid item xs={4}>
                            <span className={'highlight-text'}>✓ 확실히 되는 날</span>
                        </Grid>
                        <Grid item xs>
                            {dateSpans(attendDates)}
                        </Grid>
                    </Grid>
                    <Box height={'16px'}/>
                </>
            }
            {absentDates.length > 0 &&
                <Grid container spacing={1} sx={{fontSize: '13px'}}>
                    <Grid item xs={4}>
                        <span style={{color: '#d32f2f'}}>✓ 확실히 안되는 날</span>
                    </Grid>
                    <Grid item xs>
                        {dateSpans(absentDates)}
                    </Grid>
                </Grid>
            }
        </WhiteBox>
    )
}